import React from "react";
import { Dialog, DialogContent, IconButton, Button } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import translate from '../../../../i18n/translate';
import "./ClassPolicy.scss";

const ClassPolicy = (props: any) => {
  return (
    <Dialog open={true} onClose={() => props.setClassPolicy(false)} maxWidth="lg">
      <div className="class-policy-head">
        <div className="class-policy-title">{translate("twt_class_policy_title")}</div>
        <IconButton aria-label="delete" color="primary" onClick={() => props.setClassPolicy(false)}>
          <CloseIcon className="close-icon"></CloseIcon>
        </IconButton>
      </div>
      <DialogContent>
        <div className="class-policy-body">
          <p className="class-policy-subHeading">{translate("twt_class_policy_subHeading")}</p>
          <ol>
            <li>{translate("twt_class_policy_list01")}</li>
            <li>{translate("twt_class_policy_list02_sub1")}<br></br>
              {translate("twt_class_policy_list02_sub2")}<br></br>
              {translate("twt_class_policy_list02_sub3")}</li>
            <li>{translate("twt_class_policy_list03")}</li>
            <li>{translate("twt_class_policy_list04")}</li>
            <li>{translate("twt_class_policy_list05")}</li>
            <li>{translate("twt_class_policy_list06")}</li>
          </ol>
        </div>
      </DialogContent>
      <div className="class-policy-footer">
        <Button color="primary" variant="contained" size="medium" className="session-view-button" onClick={() => props.setClassPolicy(false)}>{translate("twt_class_policy_ok")}</Button>
      </div>
    </Dialog>
  );
}

export default ClassPolicy